import { css } from "@emotion/core";
import { color, fontSizes, fonts } from "../../theme/Theme";

export const formHelperStyles = css({
  ".select-container": {
    width: "100%"
  },
  ".date-picker": {
    width: "100%"
  },
  ".mandatory": {
    color: color.red
  },
  ".error": {
    color: color.red,
    textAlign: "right",
    fontSize: fontSizes.error
  },
  ".in-active": {
    color: color.yellow,
    fontSize: fontSizes.error
  },
  ".select-dropdown-container": {
    borderRadius: "0.25rem",
    boxShadow: `0 0.25rem 0.625rem 0 ${color.boxShadowDark}`
  },
  ".text-label-more": {
    width: "max-content",
    height: "max-content",
    textOverflow: "clip",
    fontSize: fontSizes.label,
    border: "none",
    backgroundColor: color.white,
    padding: 0,
    color: color.lightBlue,
    cursor: "pointer"
  },
  ".ant-tag-hidden": {
    display: "none"
  },
  ".anticon-plus-circle": {
    fontSize: fontSizes.buttonText
  },
  ".form-radio-btn": {
    // To get a more "fuller" checked radio button.
    ".ant-radio-inner": {
      width: "18px",
      height: "18px",
      "&:after": {
        top: "2px",
        left: "2px",
        width: "12px",
        height: "12px"
      }
    },
    // To increase padding between the Radio button and its value.
    "span.ant-radio + *": {
      paddingLeft: "1.25rem"
    },
    ".ant-radio-wrapper": {
      marginRight: "1.5rem"
    }
  }
});

// Modal styles for more tag button
export const ModalInputTagsStyles = css({
  ".ant-modal-body": {
    display: "inline-flex",
    width: "100%",
    flexWrap: "wrap",
    backgroundColor: color.white,
    minHeight: "9.625rem"
  },
  ".ant-modal-content": {
    width: "31.625rem",
    boxShadow: "0 0.375rem 1.25rem 0 #0000007d"
  },
  ".ant-modal-header": {
    backgroundColor: color.light
  },
  ".ant-tag": {
    display: "flex",
    alignItems: "center",
    margin: "0.375rem",
    width: "8.75rem",
    height: "1.3rem",
    borderRadius: "1.5rem",
    backgroundColor: color.white
  },
  ".ant-modal-title": {
    color: color.white,
    fontSize: fontSizes.cardLabel,
    fontFamily: fonts.bold,
    textTransform: "uppercase"
  },
  ".ant-modal-close-x .ant-modal-close-icon": {
    color: color.white
  },
  ".tag": {
    width: "max-content",
    alignItems: "center",
    color: color.secondary
  },
  ".ant-tag-hidden": {
    display: "none"
  },
  ".ant-tag-has-color .anticon-close ": {
    color: color.secondary,
    padding: "0.1rem",
    height: "1.2rem"
  },
  ".error,.in-active": {
    textAlign: "right",
    fontSize: fontSizes.error
  },
  ".error": {
    color: color.red
  },
  ".in-active": {
    color: color.yellow
  }
});

export const clearButtonStyles = { color: "black", cursor: "pointer" };
